import { useState } from "react";
import { rpcCall } from "../ws/client";
import "../styles/DisputeModal.scss";

interface DisputeModalProps {
    dealId: string;
    orderId: string;
    wallet: string;
    onClose: () => void;
    onCreated: () => void;
}

const DISPUTE_REASONS = [
    { value: "payment_not_received", label: "Платёж не получен" },
    { value: "payment_not_sent", label: "Платёж не отправлен" },
    { value: "wrong_amount", label: "Неверная сумма" },
    { value: "other", label: "Другое" },
];

export default function DisputeModal({ dealId, orderId, wallet, onClose, onCreated }: DisputeModalProps) {
    const [reason, setReason] = useState("payment_not_received");
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!description.trim()) {
            alert("Пожалуйста, опишите проблему");
            return;
        }

        setLoading(true);
        try {
            const response = await rpcCall("disputes.create", {
                order_id: orderId,
                deal_id: dealId,
                initiator: wallet,
                reason,
                description: description.trim(),
            });

            if (response.error) {
                alert(response.error.message);
            } else {
                alert("Спор успешно открыт. Администратор рассмотрит вашу жалобу.");
                onCreated();
                onClose();
            }
        } catch (err) {
            console.error(err);
            alert("Ошибка при открытии спора");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Открыть спор</h2>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Причина спора</label>
                        <select value={reason} onChange={(e) => setReason(e.target.value)}>
                            {DISPUTE_REASONS.map((r) => (
                                <option key={r.value} value={r.value}>
                                    {r.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Описание проблемы</label>
                        <textarea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Подробно опишите проблему..."
                            rows={5}
                            required
                        />
                    </div>

                    <div className="modal-actions">
                        <button type="button" onClick={onClose} className="btn-secondary">
                            Отмена
                        </button>
                        <button type="submit" disabled={loading} className="btn-primary">
                            {loading ? "Отправка..." : "Открыть спор"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
